import {
  Box,
  Button,
  Flex,
  Text,
  ButtonGroup,
  Grid,
  GridItem,
  Textarea,
  Input,
  VisuallyHidden,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Select,
  Tooltip,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import {
  getIncomingApplications,
  getIncomingApplicationById,
  approveApplication,
  cancelAudit,
} from "./AuditorSlice";
import { FiUpload } from "react-icons/fi";
import { useEffect } from "react";
import { FileIcon, RemoveIcon } from "../../assets/svgs/Icons";
import axios from "axios";
import isAllowed from "../../routing/isAllowed";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { DocumentViewer } from "../../Components/common/DocumentViewer";
import moment from "moment";
import { toast } from "react-toastify";
import DOCUMENT_FROM from "../../Common/Constants";
import { checkFileTypesAndSize } from "../../Common/utils";
import CustomAlertDialog from "../../Components/CustomAlertDialog";

function RegistrationCertificateAuditor() {
  const apiUrl = process.env.REACT_APP_API_URL;

  const { id } = useParams();
  const dispatch = useDispatch();
  const { application } = useSelector((state) => state.auditor);

  const [status, setStatus] = useState("idle");
  const [isLoading, setIsLoading] = useState(false);
  const [auditReportFile, setAuditReportFile] = useState(null);
  const [ncReportFile, setNcReportFile] = useState(null);
  const [legalDocumentFile, setLegalDocumentFile] = useState(null);
  const { userData } = useSelector((state) => state.auth);
  const [comment, setComment] = useState("");
  const [remarks, setRemarks] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessage1, setErrorMessage1] = useState("");
  const [errorMessage2, setErrorMessage2] = useState("");
  const [isOpenMod, setIsOpenMod] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [retrying, setRetrying] = useState(false);

  const onCloseMod = () => setIsOpenMod(false);
  const onClose = () => setIsOpen(false);

  const token = localStorage.getItem("cu_user");

  const handleFileChange = (
    file,
    setter,
    maxSize,
    errorSetter,
    successMessage
  ) => {
    const { isValid, error } = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      maxSize
    );
    if (!isValid) {
      errorSetter(error);
      toast.error(error);
      return;
    }
    setter(file);
    toast.success(successMessage);
    errorSetter("");
  };

  const handleNcReportFileChange = (event) => {
    const file = event.target.files[0];
    handleFileChange(
      file,
      setNcReportFile,
      10485760,
      setErrorMessage1,
      "NC Report document uploaded successfully"
    );
  };

  const handleAuditReportFileChange = (event) => {
    const file = event.target.files[0];
    handleFileChange(
      file,
      setAuditReportFile,
      10485760,
      setErrorMessage,
      "Audit Report document uploaded successfully"
    );
  };

  const handleLegalDocumentFileChange = (event) => {
    const file = event.target.files[0];
    handleFileChange(
      file,
      setLegalDocumentFile,
      52428800,
      setErrorMessage2,
      "Legal document uploaded successfully"
    );
  };

  const clearErrorMessage = () => setErrorMessage("");
  const clearErrorMessage1 = () => setErrorMessage1("");
  const clearErrorMessage2 = () => setErrorMessage2("");
  const handleCommentChange = (event) => setComment(event.target.value);

  const getList = async (id) => {
    try {
      setStatus("pending");
      setLoadError(null);
      const result = await dispatch(getIncomingApplicationById(id));
      if (result?.payload) {
        setStatus("success");
      } else if (result?.error) {
        setLoadError("Failed to load application. Please try again.");
        setStatus("failed");
      }
    } catch (error) {
      setLoadError(
        "Failed to load application. Token may have expired. Please refresh the page."
      );
      setStatus("failed");
      console.error(error);
    }
  };

  const handleRetry = () => {
    setRetrying(true);
    getList(encodeURIComponent(id));
    setTimeout(() => setRetrying(false), 1000);
  };

  const navigate = useNavigate();
  const handleGoBack = () => navigate(-1);

  const handleSubmit = async (id) => {
    setIsLoading(true);
    onCloseMod();
    let legalReportRequest, auditReportRequest, ncReportRequest;

    if (!auditReportFile && !ncReportFile && !legalDocumentFile) {
      setIsLoading(false);
      return toast.info("Upload supporting documents");
    }

    try {
      if (auditReportFile) {
        const auditReportData = new FormData();
        auditReportData.append("document", auditReportFile);
        auditReportData.append("doc_type", "AUDIT-REPORT");
        auditReportData.append("userType", "ADMIN");
        auditReportData.append("documentInfo", "AUDIT-REPORT");
        auditReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: auditReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (ncReportFile) {
        const ncReportData = new FormData();
        ncReportData.append("document", ncReportFile);
        ncReportData.append("doc_type", "NC-REPORT");
        ncReportData.append("userType", "ADMIN");
        ncReportData.append("documentInfo", "NC-REPORT");
        ncReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: ncReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (legalDocumentFile) {
        const legalReportData = new FormData();
        legalReportData.append("document", legalDocumentFile);
        legalReportData.append("doc_type", "LEGAL-DOCUMENT");
        legalReportData.append("userType", "ADMIN");
        legalReportData.append("documentInfo", "LEGAL-DOCUMENT");
        legalReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: legalReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      const values = {
        comment: comment,
        auditReport: auditReportRequest?.data?.data?._id || null,
        ncReport: ncReportRequest?.data?.data?._id || null,
        legalDocument: legalReportRequest?.data?.data?._id || null,
      };

      dispatch(approveApplication({ id: id, values: values }));
      navigate(-1);
      setAuditReportFile(null);
      setNcReportFile(null);
      setLegalDocumentFile(null);
      setIsLoading(false);
      setComment("");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const cancelAuditForm = (id) => {
    let values = { comment: comment };
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(cancelAudit({ id, values }));
      setIsLoading(false);
      setComment("");
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
    onClose();
    navigate(-1);
  };

  // Fixed: was [] so remarks never updated; changed to [application]
  useEffect(() => {
    const filteredRemarks = application?.remarks?.filter(
      (data) => data.comment
    );
    setRemarks(filteredRemarks);
  }, [application]);

  useEffect(() => {
    getList(encodeURIComponent(id));
  }, [dispatch, id]);

  // Shared text styles
  const labelProps = {
    color: "#141D43",
    fontSize: "md",
    fontWeight: "700",
    fontFamily: "font.roboto",
  };
  const valueProps = {
    color: "#464C64",
    fontSize: "sm",
    marginTop: "1rem",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  };

  return (
    <Box
      marginBottom={"2rem"}
      padding={{ base: "1rem", md: "2rem", lg: "3rem" }}
    >
      {/* Error Message Display */}
      {loadError && status === "failed" && (
        <Box
          bg="red.50"
          border="1px solid"
          borderColor="red.200"
          borderRadius="md"
          p="4"
          mb="4"
          color="red.800"
        >
          <Flex justifyContent="space-between" alignItems="center">
            <Text>{loadError}</Text>
            <Button
              size="sm"
              colorScheme="red"
              variant="outline"
              onClick={handleRetry}
              isLoading={retrying}
            >
              Retry
            </Button>
          </Flex>
        </Box>
      )}
      {/* ── Go Back ── */}
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>

      <Box marginTop="2rem">
        <Text
          color={"#141D43"}
          fontSize={{ base: "xl", md: "2xl" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Registration Certificate
        </Text>
      </Box>

      {/* Gradient Banner */}
      <Box
        marginTop={"1.5rem"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft={{ base: "-1rem", md: "-2rem", lg: "-3rem" }}
        marginRight={{ base: "-1rem", md: "-2rem", lg: "-3rem" }}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
        fontSize={{ base: "sm", md: "md" }}
        wordBreak="break-word"
        overflowWrap="break-word"
      >
        Application #{application?.id}
      </Box>

      {/* ── Applicant Details Card ── */}
      <Box
        bg="#fff"
        padding={{ base: "1rem", md: "2rem" }}
        marginTop="2rem"
        borderRadius={"15px"}
        overflow="hidden"
        maxW="100%"
      >
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          mb="1rem"
        >
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Applicant Details
        </Text>

        <Box paddingLeft={{ base: "0.5rem", md: "3rem" }}>
          {/* Organisation Name */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Name of Organisation</Text>
            <Text {...valueProps}>
              {application?.audit_company?.name ||
                application?.audit_application?.name ||
                application?.audit_scope?.scop_company?.name ||
                "N/A"}
            </Text>
          </Box>

          {/* Address */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Address</Text>
            <Text {...valueProps}>
              {application?.audit_company?.address?.raw_address ||
                application?.audit_application?.address?.raw_address ||
                application?.audit_scope?.scop_company?.address?.raw_address ||
                "N/A"}
            </Text>
          </Box>

          {/* City / State */}
          <Grid
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            gap={"1.5rem"}
            marginBottom={"1rem"}
          >
            <GridItem>
              <Text {...labelProps}>City</Text>
              <Text {...valueProps}>
                {application?.audit_company?.address?.city ||
                  application?.audit_application?.address?.city ||
                  application?.audit_scope?.scop_company?.address?.city ||
                  "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>State</Text>
              <Text {...valueProps}>
                {application?.audit_company?.address?.state ||
                  application?.audit_application?.address?.state ||
                  application?.audit_scope?.scop_company?.address?.state ||
                  "N/A"}
              </Text>
            </GridItem>
          </Grid>

          {/* Pincode / Country — removed inline style overflow:hidden+ellipsis that was cutting off pincodes */}
          <Grid
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            gap={"1.5rem"}
            marginBottom={"1rem"}
          >
            <GridItem>
              <Text {...labelProps}>Pincode</Text>
              <Text {...valueProps}>
                {application?.audit_company?.address?.pinCode ||
                  application?.audit_application?.address?.pinCode ||
                  application?.audit_scope?.scop_company?.address?.pinCode ||
                  "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Country</Text>
              <Text {...valueProps}>
                {application?.audit_company?.address?.country ||
                  application?.audit_application?.address?.country ||
                  application?.audit_scope?.scop_company?.address?.country ||
                  "N/A"}
              </Text>
            </GridItem>
          </Grid>
        </Box>

        {/* Section: Legal Representative */}
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          mb="5px"
        >
          Legal Representative
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="10%"
          marginBottom={"1rem"}
        ></Box>
        <Box paddingLeft={{ base: "0.5rem", md: "3rem" }}>
          <Grid
            templateColumns={{
              base: "1fr",
              sm: "repeat(2, 1fr)",
              lg: "repeat(4, 1fr)",
            }}
            gap={"1.5rem"}
            marginBottom={"1rem"}
          >
            <GridItem>
              <Text {...labelProps}>Name</Text>
              <Text {...valueProps}>
                {application?.audit_company?.legalRepresentative?.name ||
                  application?.audit_application?.legalRepresentative?.name ||
                  application?.audit_scope?.scop_company?.legalRepresentative
                    ?.name ||
                  "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Contact</Text>
              <Text {...valueProps}>
                {application?.audit_company?.legalRepresentative?.contact ||
                  application?.audit_application?.legalRepresentative
                    ?.contact ||
                  application?.audit_scope?.scop_company?.legalRepresentative
                    ?.contact ||
                  "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Email</Text>
              <Text {...valueProps} wordBreak="break-all">
                {application?.audit_company?.legalRepresentative?.email ||
                  application?.audit_application?.legalRepresentative?.email ||
                  application?.audit_scope?.scop_company?.legalRepresentative
                    ?.email ||
                  "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Company Scale</Text>
              <Text {...valueProps}>
                {application?.audit_company?.companyScale ||
                  application?.audit_scope?.scop_company?.companyScale ||
                  "N/A"}
              </Text>
            </GridItem>
          </Grid>
        </Box>

        {/* Section: Point of Contact */}
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          mb="5px"
        >
          Point of Contact
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="10%"
          marginBottom={"1rem"}
        ></Box>
        <Box paddingLeft={{ base: "0.5rem", md: "3rem" }}>
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Name</Text>
            <Text {...valueProps}>
              {application?.audit_company?.contactPerson?.name ||
                application?.audit_application?.contactPerson?.name ||
                application?.audit_scope?.scop_company?.contactPerson?.name ||
                "N/A"}
            </Text>
          </Box>

          <Grid
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            gap={"1.5rem"}
            marginBottom={"1rem"}
          >
            <GridItem>
              <Text {...labelProps}>Email</Text>
              <Text {...valueProps} wordBreak="break-all">
                {application?.audit_company?.contactPerson?.email ||
                  application?.audit_application?.contactPerson?.email ||
                  application?.audit_scope?.scop_company?.contactPerson
                    ?.email ||
                  "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Contact Number</Text>
              <Text {...valueProps}>
                {application?.audit_company?.contactPerson?.contact ||
                  application?.audit_application?.contactPerson?.contact ||
                  application?.audit_scope?.scop_company?.contactPerson
                    ?.contact ||
                  "N/A"}
              </Text>
            </GridItem>
          </Grid>

          {/* Website */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Website/Url</Text>
            <a
              href={`${application?.audit_company?.website}`}
              target="_blank"
              rel="noreferrer"
            >
              <Text {...valueProps} wordBreak="break-all">
                {application?.audit_company?.website ||
                  application?.audit_application?.website ||
                  application?.audit_scope?.scop_company?.website ||
                  "N/A"}
              </Text>
            </a>
          </Box>

          {/* Description */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Brief Description about Organisation</Text>
            <Text {...valueProps}>
              {application?.audit_company?.description ||
                application?.audit_application?.description ||
                application?.audit_scope?.scop_company?.description ||
                "N/A"}
            </Text>
          </Box>
        </Box>
      </Box>

      {/* ── Applicant Details and Scope ── */}
      <Box
        bg="#fff"
        padding={{ base: "1rem", md: "2rem" }}
        marginTop="2rem"
        borderRadius={"15px"}
        overflow="hidden"
        maxW="100%"
      >
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          mb="1rem"
        >
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Applicant Details and scope
        </Text>

        <Box paddingLeft={{ base: "0.5rem", md: "3rem" }}>
          {/* Facility Name */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Facility/Site Name</Text>
            <Text {...valueProps}>
              {application?.audit_unit?.name || "N/A"}
            </Text>
          </Box>

          {/* Address */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Address</Text>
            <Text {...valueProps}>
              {application?.audit_unit?.address?.raw_address || "N/A"}
            </Text>
          </Box>

          {/* City / State */}
          <Grid
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            gap={"1.5rem"}
            marginBottom={"1rem"}
          >
            <GridItem>
              <Text {...labelProps}>City</Text>
              <Text {...valueProps}>
                {application?.audit_unit?.address?.city || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>State</Text>
              <Text {...valueProps}>
                {application?.audit_unit?.address?.state || "N/A"}
              </Text>
            </GridItem>
          </Grid>

          {/* Pincode / Country — removed inline style that clipped pincode to 100px */}
          <Grid
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            gap={"1.5rem"}
            marginBottom={"1rem"}
          >
            <GridItem>
              <Text {...labelProps}>Pincode</Text>
              <Text {...valueProps}>
                {application?.audit_unit?.address?.pinCode || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Country</Text>
              <Text {...valueProps}>
                {application?.audit_unit?.address?.country || "N/A"}
              </Text>
            </GridItem>
          </Grid>

          {/* Type of Organisation */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Type of organization</Text>
            <Text {...valueProps}>
              {application?.audit_unit?.unitType || "N/A"}
            </Text>
          </Box>

          {/* Type of Process */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Type of Process</Text>
            <Menu>
              <MenuButton
                mt="1rem"
                as={Button}
                bg={"#EDF3F8"}
                w={{ base: "100%", sm: "50%" }}
                h={"43px"}
              >
                View Processes
              </MenuButton>
              <MenuList borderRadius={"15px"}>
                {application?.audit_unit?.unit_processes?.map((process) => (
                  <MenuItem
                    key={process?.name}
                    bg="#EDF3F8"
                    mt={"1rem"}
                    w={"90%"}
                    h={"43px"}
                    borderRadius={"15px"}
                    textAlign={"center"}
                    justifyContent="center"
                    ml={"0.5rem"}
                  >
                    {process?.name}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          </Box>

          {/* Programs applied for */}
          <Box marginBottom={"1rem"}>
            <Text {...labelProps}>Programs applied for</Text>
            <Box display="flex" flexWrap="wrap" gap="0.5rem" mt="1rem">
              {application?.audit_unit?.unit_programs?.map((program) => (
                <Button
                  key={program?._id}
                  bg={"#EDF3F8"}
                  color="#141D43"
                  cursor={"pointer"}
                  whiteSpace="normal"
                  wordBreak="break-word"
                  h="auto"
                  py="0.5rem"
                  px="1rem"
                >
                  <Text>{program?.name}</Text>
                </Button>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ── RC Documents ── */}
      <Box
        marginTop="2rem"
        marginBottom="2rem"
        bg="#fff"
        borderRadius={"15px"}
        padding={{ base: "1rem", md: "2rem" }}
        overflow="hidden"
        maxW="100%"
      >
        <Text
          color={"#141D43"}
          fontSize={{ base: "md", md: "lg" }}
          fontWeight={"800"}
          padding="0.5rem"
        >
          RC Documents
        </Text>
        {application?.audit_company?.company_document?.length > 0 ? (
          <DocumentViewer
            document={application?.audit_company?.company_document}
            referenceId={application?._id}
            doc_from={DOCUMENT_FROM.AUDIT}
          />
        ) : (
          <Box
            bg="#FFFFFF"
            w={{ base: "100%", sm: "175px" }}
            h={"125px"}
            borderRadius={"15px"}
            textAlign="center"
            display="flex"
            alignItems="center"
            mb="1rem"
            boxShadow={"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
          >
            <Text padding={"1rem"}>No Application Document Found</Text>
          </Box>
        )}
      </Box>

      {/* ── Auditor Uploaded Docs or Upload Section ── */}
      {application?.status === "DONE" || application?.status === "CANCELLED" ? (
        <Box
          bg="#FFFFFF"
          marginTop="2rem"
          borderRadius={"15px"}
          paddingBottom="1rem"
          overflow="hidden"
          maxW="100%"
        >
          <Text
            color={"#141D43"}
            fontSize={{ base: "md", md: "lg" }}
            fontWeight={"800"}
            padding="1rem"
          >
            Auditor uploaded Documents
          </Text>

          <Box margin={"1rem"}>
            {application?.audit_auditReport?.length === 0 &&
            application?.audit_legalDocument?.length === 0 &&
            application?.audit_ncReport?.length === 0 ? (
              <Box
                bg="#FFFFFF"
                w={{ base: "100%", sm: "175px" }}
                h={"125px"}
                borderRadius={"15px"}
                boxShadow={"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                textAlign="center"
                display="flex"
                alignItems="center"
                mb="1rem"
              >
                <Text padding={"1rem"}>No documents available</Text>
              </Box>
            ) : (
              <Flex flexWrap="wrap" gap="1rem">
                <DocumentViewer
                  document={application?.audit_auditReport}
                  referenceId={application?._id}
                  doc_from={DOCUMENT_FROM.AUDIT}
                />
                <DocumentViewer
                  document={application?.audit_legalDocument}
                  referenceId={application?._id}
                  doc_from={DOCUMENT_FROM.AUDIT}
                />
                <DocumentViewer
                  document={application?.audit_ncReport}
                  referenceId={application?._id}
                  doc_from={DOCUMENT_FROM.AUDIT}
                />
              </Flex>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          bg="#EDF3F8"
          marginTop="2rem"
          borderRadius={"15px"}
          padding={{ base: "1rem", md: "2rem" }}
          overflow="hidden"
          maxW="100%"
        >
          {/* Upload buttons — responsive flex wrap instead of fixed 6-col grid */}
          <Flex flexWrap="wrap" gap="1rem" mt="1rem">
            <Button
              bg="#FFFFFF"
              color={"black"}
              w={{ base: "100%", sm: "250px" }}
              h={"164px"}
              leftIcon={<FiUpload />}
              borderRadius={"15px"}
              as="label"
              htmlFor="file-upload-audit"
              variant="outline"
            >
              Upload Audit Report
              <VisuallyHidden>
                <input
                  id="file-upload-audit"
                  type="file"
                  onChange={handleAuditReportFileChange}
                />
              </VisuallyHidden>
            </Button>

            <Button
              bg="#FFFFFF"
              color={"#000000"}
              w={{ base: "100%", sm: "250px" }}
              h={"164px"}
              leftIcon={<FiUpload />}
              borderRadius={"15px"}
              as="label"
              htmlFor="file-upload-nc"
              variant="outline"
            >
              Upload NC report
              <VisuallyHidden>
                <input
                  id="file-upload-nc"
                  type="file"
                  onChange={handleNcReportFileChange}
                />
              </VisuallyHidden>
            </Button>

            <Button
              bg="#FFFFFF"
              color={"black"}
              w={{ base: "100%", sm: "250px" }}
              h={"164px"}
              leftIcon={<FiUpload />}
              borderRadius={"15px"}
              as="label"
              htmlFor="file-upload-legal"
              variant="outline"
            >
              Upload Legal Document
              <VisuallyHidden>
                <input
                  id="file-upload-legal"
                  type="file"
                  onChange={handleLegalDocumentFileChange}
                />
              </VisuallyHidden>
            </Button>
          </Flex>

          {/* File previews — responsive flex wrap instead of fixed 6-col grid */}
          <Flex flexWrap="wrap" gap="1rem" mt="2rem" mb="1rem">
            {auditReportFile && (
              <Box bg="#FFFFFF" w={"200px"} h={"150px"} borderRadius={"15px"}>
                <Box display={"flex"} justifyContent={"right"}>
                  <Button
                    borderColor="#FFFFFF"
                    bg="#ffffff"
                    size="sm"
                    variant="outline"
                    onClick={() => setAuditReportFile(null)}
                    leftIcon={<RemoveIcon />}
                  ></Button>
                </Box>
                <Box display={"flex"} justifyContent={"center"}>
                  <FileIcon />
                </Box>
                <Tooltip label={auditReportFile?.name}>
                  <Text
                    margin={"auto"}
                    width={"130px"}
                    whiteSpace={"nowrap"}
                    overflow={"hidden"}
                    textOverflow={"ellipsis"}
                  >
                    {auditReportFile?.name}
                  </Text>
                </Tooltip>
              </Box>
            )}

            {ncReportFile && (
              <Box bg="#FFFFFF" w={"200px"} h={"150px"} borderRadius={"15px"}>
                <Box display={"flex"} justifyContent={"right"}>
                  <Button
                    borderColor="#FFFFFF"
                    bg="#ffffff"
                    size="sm"
                    variant="outline"
                    onClick={() => setNcReportFile(null)}
                    leftIcon={<RemoveIcon />}
                  ></Button>
                </Box>
                <Box display={"flex"} justifyContent={"center"}>
                  <FileIcon />
                </Box>
                <Tooltip label={ncReportFile?.name}>
                  <Text
                    width={"130px"}
                    margin={"auto"}
                    whiteSpace={"nowrap"}
                    overflow={"hidden"}
                    textOverflow={"ellipsis"}
                  >
                    {ncReportFile?.name}
                  </Text>
                </Tooltip>
              </Box>
            )}

            {legalDocumentFile && (
              <Box
                bg="#FFFFFF"
                w={"200px"}
                h={"150px"}
                borderRadius={"15px"}
                textAlign={"center"}
              >
                <Box display={"flex"} justifyContent={"right"}>
                  <Button
                    borderColor="#FFFFFF"
                    bg="#ffffff"
                    size="sm"
                    variant="outline"
                    onClick={() => setLegalDocumentFile(null)}
                    leftIcon={<RemoveIcon />}
                  ></Button>
                </Box>
                <Box display={"flex"} justifyContent={"center"}>
                  <FileIcon />
                </Box>
                <Tooltip label={legalDocumentFile?.name}>
                  <Text
                    width={"130px"}
                    margin={"auto"}
                    whiteSpace={"nowrap"}
                    overflow={"hidden"}
                    textOverflow={"ellipsis"}
                  >
                    {legalDocumentFile?.name}
                  </Text>
                </Tooltip>
              </Box>
            )}
          </Flex>

          {/* Error messages — responsive width */}
          {errorMessage && (
            <Box mt="1rem" display={"flex"} justifyContent={"center"}>
              <Box
                bg="crimson"
                color="white"
                p="1rem"
                borderRadius="15px"
                mb="1rem"
                w={{ base: "100%", md: "60%" }}
                textAlign={"center"}
              >
                {errorMessage}
                <Button
                  size="sm"
                  variant="outline"
                  ml="1rem"
                  bg="white"
                  color="black"
                  onClick={clearErrorMessage}
                >
                  <RemoveIcon />
                </Button>
              </Box>
            </Box>
          )}
          {errorMessage1 && (
            <Box mt="1rem" display={"flex"} justifyContent={"center"}>
              <Box
                bg="crimson"
                color="white"
                p="1rem"
                borderRadius="15px"
                mb="1rem"
                w={{ base: "100%", md: "60%" }}
                textAlign={"center"}
              >
                {errorMessage1}
                <Button
                  size="sm"
                  variant="outline"
                  ml="1rem"
                  bg="white"
                  color="black"
                  onClick={clearErrorMessage1}
                >
                  <RemoveIcon />
                </Button>
              </Box>
            </Box>
          )}
          {errorMessage2 && (
            <Box mt="1rem" display={"flex"} justifyContent={"center"}>
              <Box
                bg="crimson"
                color="white"
                p="1rem"
                borderRadius="15px"
                mb="1rem"
                w={{ base: "100%", md: "60%" }}
                textAlign={"center"}
              >
                {errorMessage2}
                <Button
                  size="sm"
                  variant="outline"
                  ml="1rem"
                  bg="white"
                  color="black"
                  onClick={clearErrorMessage2}
                >
                  <RemoveIcon />
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )}

      {/* ── Remarks (non-admin) ── */}
      {!userData?.role?.includes("ADMIN") ? (
        <Box width={"100%"} mt="1.5rem">
          <Text {...labelProps} margin={"1rem"}>
            Remarks
          </Text>
          <TableContainer overflowX="auto">
            <Table
              variant={"simple"}
              size={{ base: "sm", md: "md" }}
              bg={"#fff"}
              borderRadius={"15px"}
            >
              <Thead>
                <Tr>
                  <Th color="brand.blue" textTransform="capitalize">
                    Sr no.
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Date Time
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Comment by
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Remarks
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {remarks?.length ? (
                  remarks.map((remark, index) => (
                    <Tr key={index}>
                      <Td>{index + 1}</Td>
                      <Td whiteSpace="nowrap">
                        {moment(remark?.time).format("DD-MM-YYYY hh:mm")}
                      </Td>
                      <Td>
                        {remark.userId &&
                          `${remark?.userId?.name} (${remark?.userId?.id})`}
                      </Td>
                      <Td>{remark?.comment || "N/A"}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                      No remarks for now
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      ) : null}

      {/* ── Logs (admin) ── */}
      {userData?.role?.includes("ADMIN") ? (
        <Box width={"100%"} mt="1.5rem">
          <Text {...labelProps} margin={"1rem"}>
            Logs
          </Text>
          <TableContainer overflowX="auto">
            <Table
              variant={"simple"}
              size={{ base: "sm", md: "md" }}
              bg={"#fff"}
              borderRadius={"15px"}
            >
              <Thead>
                <Tr>
                  <Th color="brand.blue" textTransform="capitalize">
                    Sr no.
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Date Time
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    User
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Logs
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {application?.remarks?.length ? (
                  application?.remarks?.map((remark, index) => (
                    <Tr key={index}>
                      <Td>{index + 1}</Td>
                      <Td whiteSpace="nowrap">
                        {moment(remark?.time).format("DD-MM-YYYY hh:mm")}
                      </Td>
                      <Td>
                        {remark.userId &&
                          `${remark?.userId?.name} (${remark?.userId?.id})`}
                      </Td>
                      <Td>{remark?.log || "N/A"}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                      No logs for now
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      ) : null}

      {/* ── Comment & Action Buttons ── */}
      {application?.status === "CANCELLED" ||
      application?.status === "DONE" ||
      application?.status === "" ? (
        <Box mt="1rem"></Box>
      ) : (
        <>
          <Box mt="2rem">
            <Textarea
              type="text"
              color={"#141D43"}
              border="none"
              w={{ base: "100%", md: "522px" }}
              height={"164px"}
              bg={"#fff"}
              value={comment}
              placeholder="Enter Remarks"
              onChange={handleCommentChange}
              fontSize={"16px"}
              borderRadius={"15px"}
              fontWeight={"400"}
            />
          </Box>
          <Box mt={"4rem"}>
            <Flex
              gap={2}
              flexDirection={{ base: "column", sm: "row" }}
              alignItems={{ base: "stretch", sm: "center" }}
            >
              <Button
                bg="#52BBFF"
                _hover={{ bg: "#52BBFF" }}
                color={"#ffffff"}
                w={{ base: "100%", sm: "193px" }}
                h="50px"
                disabled={isLoading}
                onClick={() => setIsOpenMod(true)}
              >
                Submit
              </Button>
              <Button
                bg="crimson"
                _hover={{ bg: "crimson" }}
                color={"#ffffff"}
                w={{ base: "100%", sm: "193px" }}
                h="50px"
                disabled={isLoading}
                onClick={() => setIsOpen(true)}
              >
                Cancel
              </Button>
            </Flex>
          </Box>
        </>
      )}

      <CustomAlertDialog
        isOpen={isOpen}
        onClose={onClose}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="red"
        onConfirm={() => cancelAuditForm(application?.unitId)}
      />

      <CustomAlertDialog
        isOpen={isOpenMod}
        onClose={onCloseMod}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="#52BBFF"
        onConfirm={() => handleSubmit(application?._id)}
      />
    </Box>
  );
}

export default isAllowed(RegistrationCertificateAuditor);
